// Mirage Foods Product Data

export const pastryProducts = [
  {
    id: 'creme-brulee',
    title: 'Crème Brûlée Base',
    description: 'A gourmet mix made with real egg yolk, delivering the authentic taste and creamy texture of traditional crème brûlée using premium quality ingredients. Prepares in a fraction of the time normally required for this dessert favorite. Simply add heavy cream, half and half, or whole milk and reconstitute while hot.',
    packaging: '5 lb foil-sealed bags (5/case)',
    netWeight: '25 lbs',
    image: '/images/products/creme-brulee-product.png'
  },
  {
    id: 'instant-pastry-cream',
    title: 'Instant Pastry Cream',
    description: 'A classic French-style pastry cream in an instant mix. Just add water and half and half, or water alone, to reconstitute this creamy, delicious pastry cream. Ready in 5 minutes. Perfect for éclairs, Napoleons, tarts, cupcakes, wedding cakes, or Boston cream pies.',
    packaging: '25 lb poly bag in box',
    netWeight: '25 lbs',
    image: '/images/products/pastry-cream-product.jpg'
  },
  {
    id: 'miragelle-mousse',
    title: 'Miragelle Instant Mousse',
    description: 'Miragelle is a versatile, one-step mix that greatly simplifies the creation of dessert mousse with excellent texture and flavor. Blend the mix with liquid (milk, cream, water, or fruit juice combination). Works beautifully with mango, raspberry, peach, pomegranate, cappuccino, or chocolate for signature desserts with superb texture and taste. The only limit is your imagination!',
    packaging: '3.5 lb foil-sealed bags (5/case)',
    netWeight: '17.5 lbs',
    image: '/images/products/gelato-product.jpg'
  },
  {
    id: 'ice-cream-base',
    title: 'Ice Cream Base',
    description: 'Our Ice Cream Base greatly simplifies the creation of excellent gourmet, hand-churned ice cream with superb taste and texture. Simply blend the ice cream base with half and half and the flavor of your choice, allow to set for one hour, and churn for luxurious ice cream with exceptional taste and texture.',
    packaging: '25 lb bulk bag-in-box carton',
    netWeight: '25 lbs',
    image: '/images/products/ice-cream-product.jpg'
  },
  {
    id: 'panna-cotta',
    title: 'Panna Cotta Base',
    description: 'The classic Italian dessert in a quick and easy-to-use mix. The taste and texture of crème brûlée with a light, pleasing gelatinous finish that provides the perfect contrast to creamy layers.',
    packaging: '5 lb foil-sealed bags (5/case)',
    netWeight: '25 lbs',
    image: '/images/products/panna-cotta-product.jpg'
  },
  {
    id: 'gelato-base',
    title: 'Gelato Base',
    description: 'Mirage Gelato Base greatly simplifies the creation of a creamy smooth gelato with excellent texture and flavor. Blend with milk and cream for superior results. Churn in ice cream freezer or soft serve equipment. Blend with berries, fruit puree, chocolate, caramel or matcha powder. Requires lower refrigeration temps than ice cream and holds form and shape longer.',
    packaging: '25 lbs bulk, poly bag in box',
    netWeight: '25 lbs',
    image: '/images/products/mousse-product.jpg'
  },
  {
    id: 'whipped-dairy-topping',
    title: 'Whipped Dairy Topping',
    description: 'Made with real milk and cream, Mirage\'s natural mix makes delicious whipped dairy topping that is rich in creamy flavor with the smoothest texture. Simply blend this mix with water for three to four minutes and use for cake icing, fillings, pastry, parfaits, fruit cups and ice cream.',
    packaging: '3.5 lbs foil, sealed bags (5/case)',
    netWeight: '17.5 lbs',
    image: '/images/products/whipped-topping-product.jpg'
  },
  {
    id: 'cream-powder',
    title: 'Cream Powder (32% fat)',
    description: 'Mirage Cream Powder (32% fat) is an all natural, cream/milk powder concentrate that is a reliable, shelf-stable alternative to liquid heavy cream, half-and-half, and milk for all hot and cold applications. This fat level is specifically designed as a liquid dairy substitute in ice cream machines. Also suitable for crème brûlée. Hydrate at 6 to 1 water to mix ratio for milk, 4 to 1 for half and half or 3 to 1 for heavy cream.',
    packaging: '25 lbs bulk, poly bag in box',
    netWeight: '25 lbs',
    image: '/images/products/cream-powder-product.png'
  }
];

export const bakeryProducts = [
  {
    id: 'lava-cake',
    title: 'Lava Cake Mix',
    description: 'Create the globally beloved chocolate lava cake with ease. Simply combine Mirage\'s Lava Cake Mix with warm milk and a few tablespoons of butter for a rich, moist cake with perfect quality, taste, and texture.',
    image: '/images/products/lava-cake.png'
  },
  {
    id: 'vegan-brownie',
    title: 'Vegan Brownie Mix',
    description: 'You won\'t believe this decadent chocolate brownie is vegan! A plant-based brownie mix so rich in chocolate flavor and completely free of eggs and dairy. Customize texture by adjusting water or oil content and varying bake times.',
    image: '/images/products/vegan-brownie.jpg'
  },
  {
    id: 'devils-food',
    title: 'Devil\'s Food Cake Mix',
    description: 'This decadent chocolate cake mix is ready in minutes. Add only water and oil to create a rich, moist Devil\'s Food cake. Achieve excellent results in a fraction of the time. Available in 50 lb bulk, Kraft poly-lined bakery bags. This egg-complete mix requires only water and oil.',
    image: '/images/products/devils-food.jpg'
  },
  {
    id: 'bubble-waffle',
    title: 'Bubble Waffle Mix',
    description: 'A complete mix for gourmet waffles with enhanced flexibility for cones and creative designs. Also suitable for pancakes and Belgian-style classic waffles.',
    image: '/images/products/bubble-waffle.jpg'
  },
  {
    id: 'churro',
    title: 'Churro Mix',
    description: 'A complete mix delivering the perfect balance of flavor, texture, and flexibility for creating authentic cinnamon churros in sticks or custom shapes.',
    image: '/images/products/churro.jpg'
  },
  {
    id: 'crepe',
    title: 'Crepe Mix',
    description: 'A complete gourmet crepe mix enriched with whole eggs and milk for exceptional flavor and texture.',
    image: '/images/products/crepe.jpg'
  },
  {
    id: 'red-velvet',
    title: 'Red Velvet Cake Mix',
    description: 'A quick and easy mix that delivers the moist, rich flavor of classic red velvet cake in a fraction of the time. This egg-complete mix requires only water and oil.',
    image: '/images/products/red-velvet.png'
  },
  {
    id: 'golden-yellow',
    title: 'Golden Yellow Cake Mix',
    description: 'Mirage\'s Golden Yellow Cake delivers a rich, moist experience. This versatile base mix works in countless applications. Add flavors during preparation to create endless varieties. Prepares in a fraction of the time compared to conventional methods. This egg-complete mix requires only water and oil.',
    image: '/images/products/golden-yellow.jpg'
  }
];

export const bakeryAdvantages = [
  'Speed: Reduced production times',
  'Quality: Premium batters with consistently excellent results',
  'Variety: Diverse product range to meet consumer demand',
  'Efficiency: Optimized flour usage to minimize costs',
  'Ease of Use: Pre-measured ingredients ideal for less experienced staff',
  'Convenience: Simple to stock and store',
  'Consistency: Guaranteed quality with every batch'
];

export const homepageFeatures = [
  {
    id: 'pastry',
    title: 'PASTRY PRODUCTS',
    description: 'Mirage specializes in the formulation of customized, gourmet dessert mixes designed to improve the efficiency of your Production kitchen and increase your bottom line.',
    image: '/images/gallery/dessert-plate-1.jpeg',
    link: '/pastry-mixes'
  },
  {
    id: 'bakery',
    title: 'BAKERY PRODUCTS',
    description: 'There are many reasons why chefs, bakers and caterers prefer to use Mirage bakery mixes rather than create cakes from scratch.',
    image: '/images/gallery/choco-cake.jpg',
    link: '/bakery-mixes'
  },
  {
    id: 'difference',
    title: 'THE MIRAGE DIFFERENCE',
    description: 'We can help our clients introduce a complete array of elite, gourmet dessert mixes from creme brulee and cakes to ice cream and gelato bases.',
    image: '/images/gallery/matcha-cake-feature.jpeg',
    link: '/the-mirage-difference'
  },
  {
    id: 'manufacturing',
    title: 'EXCELLENCE IN MANUFACTURING',
    description: 'In today\'s challenging food industry environment, the need for constant attention to the highest health and safety standards, mixed with our desire to achieve highest quality standards, our skilled employees and custom blending capabilities combine to set us apart from other companies.',
    image: '/images/gallery/blending-equipment.jpg',
    link: '/excellence-in-manufacturing'
  }
];
